import { UniversitiesResponse, University } from "../../types/university";
import apiClient from "./apiClient";
import { ENDPOINTS } from "./config";

export interface PopularUniversitiesResponse {
  success: boolean;
  message: string;
  data: {
    universities: University[];
    total: number;
  };
}

/**
 * UniversityService for handling university-related API calls
 */
class UniversityService {
  /**
   * Get popular universities
   */
  public async getPopularUniversities() {
    return apiClient.get<PopularUniversitiesResponse>(
      ENDPOINTS.UNIVERSITIES.POPULAR_UNIVERSITIES
    );
  }

  /**
   * Get all universities with pagination and filters
   */
  public async getAllUniversities(
    page = 1,
    limit = 20,
    filters?: {
      search?: string;
      city?: string;
      sortBy?: string;
    }
  ) {
    const params: any = { page, limit };

    if (filters?.search) {
      params.search = filters.search;
    }

    if (filters?.city) {
      params.city = filters.city;
    }

    if (filters?.sortBy) {
      params.sortBy = filters.sortBy;
    }

    return apiClient.get<UniversitiesResponse>(
      ENDPOINTS.UNIVERSITIES.GET_ALL_UNIVERSITIES,
      params
    );
  }

  /**
   * Get university details by ID
   */
  public async getUniversityDetails(id: string) {
    return apiClient.get<{
      success: boolean;
      message: string;
      data: University;
    }>(ENDPOINTS.UNIVERSITIES.DETAILS(id));
  }

  /**
   * Get programs/courses for a specific university
   */
  public async getUniversityPrograms(id: string) {
    return apiClient.get<{
      success: boolean;
      message: string;
      data: any[];
    }>(ENDPOINTS.UNIVERSITIES.PROGRAMS(id), { limit: 500 });
  }
}

export const universityService = new UniversityService();

export default universityService;
